module.exports = __webpack_public_path__ + "img/cz.9e22294.png";